var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdhere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#395BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9951 8.22181C11.8206 6.34313 14.0127 5.48934 15.8914 6.31483C17.7701 7.14032 18.6239 9.33248 17.7984 11.2112L12.3442 23.624C11.5187 25.5027 9.32656 26.3565 7.44788 25.531C5.5692 24.7055 4.71542 22.5133 5.54091 20.6346L10.9951 8.22181Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4982 19.5535C16.567 17.7249 17.2945 15.4877 19.1231 14.5565C20.9517 13.6253 23.1889 14.3528 24.1201 16.1814L26.369 20.5976C27.3002 22.4262 26.5727 24.6634 24.7441 25.5946C22.9155 26.5258 20.6782 25.7983 19.7471 23.9697L17.4982 19.5535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhere);
export default __webpack_public_path__ + "static/media/Adhere.4bb51bea67b268460efeeb7d7cb9e894.svg";
export { ForwardRef as ReactComponent };